/**
 * Tiny helper to strip HTML tags into plain text — used in list cards where rich
 * formatting would look broken. Decodes the most common entities. Safe for
 * trusted HTML from our own backend (which sanitises before storing).
 */
export function stripHtml(html) {
  if (!html) return "";
  if (typeof html !== "string") return String(html);
  const noTags = html.replace(/<[^>]+>/g, " ");
  return noTags
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}
